<template>
  <div>You should have an <code>inline-template</code> directive on the component</div>
</template>
<script>
export default {
  props: ['formObject'],

  data() {
    return {
      holdingCompany: null,
      companyType: null
    }
  },

  computed: {
    holdingCompanyVisible() {
      return this.companyType === "agency"
    }
  },

  mounted() {
    const obj = JSON.parse(this.formObject)
    this.holdingCompany = obj.holding_company_id
    this.companyType = obj.organization_type
  },

  watch: {
    companyType(val) {
      if (val !== 'agency') {
        this.holdingCompany = null
      }
    }
  }
}
</script>